import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import { PulsatingIcon } from 'Storybook/local/PulsatingIcon/PulsatingIcon';
import type { ListType } from 'Types/listType';
import { LIST_TYPES } from 'Utilities/consts';
import { applyCypressData } from 'Utilities/helpers';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

import LocalTexts from './VehicleListTabs.texts';

import styles from './VehicleListTabContent.module.scss';

export interface VehicleListTabContentProps {
	id: ListType;
}

const LocalT = new MDText(LocalTexts);
const {
	buttons: {
		vehicleListTabs: { content: cypressTabIds },
	},
} = cypressIds;

export const VehicleListTabContent: React.FC<VehicleListTabContentProps> = ({ id }) => {
	const { isLiveSaleEnabled, isSaleActive } = useSaleTimes();
	const isActiveAuctionTab = id === LIST_TYPES.auction && isSaleActive && isLiveSaleEnabled;
	const icon = isActiveAuctionTab ? (
		<span className={styles.pulsatingCircle}>
			<PulsatingIcon />
		</span>
	) : null;

	return (
		<span className={styles.label} {...applyCypressData(cypressTabIds[id])}>
			{icon}
			{LocalT.translate(id)}
		</span>
	);
};
